import styledComponents from 'styled-components'

export default styledComponents.button.attrs({ className: 'button' })``



// WEBPACK FOOTER //
// ./src/components/views/buttons/Button.js